import person from "@/api/person/person"
import all_park from "@/api/all_park/all_park"
import sctcc from "@/api/sctcc/sctcc"
import achievements from "@/api/sctcc/achievements"
import supermarket from "@/api/sctcc/supermarket"
import hz_supermarket from "@/api/sctcc/hz_supermarket"
import school from "@/api/sctcc/school"
import service from "@/api/sctcc/service"
import eight_min from "@/api/eight_min/index"
import service_provider from "@/api/person/service_provider.js"
const api = {
  ...person,
  ...all_park,
  ...sctcc,
  ...achievements,
  ...supermarket,
  ...hz_supermarket,
  ...school,
  ...service,
  ...eight_min,
  ...service_provider
}
export default api;
